import React from 'react';
import { styled } from '@mui/material/styles';
import { FormControl, InputLabel, OutlinedInput, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '20px',
    '& fieldset': {
      borderColor: '#ccc',
    },
    '&:hover fieldset': {
      borderColor: '#50A579',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#50A579',
    },
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#50A579',
    },
  },
  '& .MuiInputLabel-outlined': {
    transform: 'translate(14px, -6px) scale(0.75)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
  },
}));

export const CustomTextField = ({ value, label, margin, onChange, type, error, helperText, readOnly }) => {
  return (
    <StyledFormControl variant="outlined" margin={margin} onChange={onChange}>
      <InputLabel htmlFor="custom-input"></InputLabel>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'black', ml: '12px' }}>{label}:</Typography>
      <OutlinedInput
        defaultValue={value}
        type={type ? type : 'text'}
        error={error}
        inputProps={{ readOnly: readOnly }}
      />
      {error && <Typography sx={{ color: 'red', fontSize: '0.75rem', textAlign: 'center' }}>{helperText}</Typography>}
    </StyledFormControl>
  );
};

export const CustomTextFieldMultiLine = ({ value, label, margin, onChange, type, error, helperText }) => {
  return (
    <StyledFormControl variant="outlined" margin={margin} onChange={onChange}>
      <InputLabel htmlFor="custom-input"></InputLabel>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'black', ml: '12px' }}>{label}:</Typography>
      <OutlinedInput
        placeholder={value}
        type={type ? type : 'text'}
        error={error}
        multiline
        rows={10}
      />
      {error && <Typography sx={{ color: 'red', fontSize: '0.75rem', textAlign: 'center' }}>{helperText}</Typography>}
    </StyledFormControl>
  );
};

export const CustomDatePicker = styled(DatePicker)(({ theme }) => ({
  width: '100%',

  '& .MuiInputBase-root': {
    borderRadius: '20px',
    '& fieldset': {
      borderColor: '#ccc',
    },
    '&:hover fieldset': {
      borderColor: '#50A579',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#50A579',
    },
  },

  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#50A579',
    },
  },

  'aria-hidden': undefined,

}));